import Swal from "sweetalert2";

export default {

  /**
   * Mostra apenas uma mensagem de erro
   * @param msg
   */
  /**
   * Mostra apenas uma mensagem de erro
   * @param msg
   */
  showError(msg) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      background: "#FF5252", // Error red color explicitly
      color: "#fff",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
        toast.style.fontFamily = "'Inter', 'Roboto', sans-serif"; // Fix font
      },
    });

    Toast.fire({
      icon: "error",
      title: this.extractErrorMessage(msg),
    });
  },

  /**
   * Mostra apenas uma mensagem de sucesso
   * @param msg
   */
  showSuccessMsg(msg) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      background: "#4CAF50", // Success green color
      color: "#fff",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
        toast.style.fontFamily = "'Inter', 'Roboto', sans-serif"; // Fix font
      },
    });

    Toast.fire({
      icon: "success",
      title: this.extractSuccessMessage(msg),
    });
  },

  extractErrorMessage(msg) {
    if (!msg) return "Ocorreu um erro inesperado.";

    if (typeof msg === 'string') {
      return msg;
    }

    // Handle Axios Error Response
    if (msg.response) {
      const { data, status } = msg.response;

      // Handle 402 Payment Required redirect
      if (status === 402) {
        window.location.href = `https://app.ezcont.com.br/subscribed/?${msg}`;
        return "Redirecionando...";
      }

      // 1. Check for 'message' field
      if (data && data.message) {
        return data.message;
      }

      // 2. Check for 'error' field (string or object)
      if (data && data.error) {
        return typeof data.error === 'string' ? data.error : JSON.stringify(data.error);
      }

      // 3. Check for specific 'errors' object (often validation errors)
      if (data && data.errors) {
        // Return the first error message found
        const firstKey = Object.keys(data.errors)[0];
        if (firstKey && data.errors[firstKey]) {
          return Array.isArray(data.errors[firstKey]) ? data.errors[firstKey][0] : data.errors[firstKey];
        }
      }
    }

    // Fallback for generic objects or unknown formats
    return msg.message || "Erro desconhecido. Tente novamente.";
  },

  extractSuccessMessage(msg) {
    if (!msg) return "Operação realizada com sucesso.";

    if (typeof msg === 'string') {
      return msg;
    }

    if (msg.data) {
      if (msg.data.message) return msg.data.message;
      if (typeof msg.data === 'string') return msg.data;
    }

    if (msg.message) return msg.message;

    return "Sucesso!";
  },
};
